import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import { useDispatch } from 'react-redux';
import { compose, lifecycle, withHandlers, withProps, withStateHandlers } from 'recompose';
import { getFormikError, withFormikField } from 'utils/formik';
import { StyledDatePickerWrapper } from './styled';

import { Field, Flexer } from '@ontruck/orc';
import DatePicker from 'react-datepicker';

import { setCheckTimes } from 'redux/modules/shipper-order-new/duck';

import './style.scss';
import { IS_TENANT } from 'tenant/config';

const enhance = compose(
  withFormikField,
  withProps(({ field }) => ({
    day: field.value ? moment(field.value) : null,
  })),
  withStateHandlers(
    () => ({
      repeatedOrderDateInitialized: false,
    }),
    {
      setDateInitialized: () => () => ({
        repeatedOrderDateInitialized: true,
      }),
    }
  ),
  withHandlers({
    changeDayInFormik:
      ({ onTimeChange, form }) =>
      (name, value) => {
        const { setFieldTouched, setFieldValue } = form;
        if (onTimeChange) {
          onTimeChange(name, value);
        } else {
          if (IS_TENANT) {
            name = name.split('_').slice(0, 2).join('_');
            setFieldValue(`${name}_to`, value);
            setFieldValue(`${name}_from`, value);
            setFieldTouched(`${name}_to`);
            setFieldTouched(`${name}_from`);
          } else {
            setFieldValue(name, value);
            setFieldTouched(name);
          }
        }
      },
  }),
  withHandlers({
    handleChangeDay:
      ({
        field,
        changeDayInFormik,
        isRepeated,
        setDateInitialized,
        repeatedOrderDateInitialized,
      }) =>
      (selectedDay) => {
        if (isRepeated && !repeatedOrderDateInitialized) {
          setDateInitialized();
        }

        const { name, value } = field;
        const valueMomentObject = moment(value || undefined);
        const selectedDayMomentObject = moment(selectedDay);

        const date = selectedDayMomentObject.date();
        const month = selectedDayMomentObject.month();
        const year = selectedDayMomentObject.year();

        valueMomentObject.set({ date, month, year });

        const dayAndTime = valueMomentObject.format();

        changeDayInFormik(name, dayAndTime);
      },
  }),
  lifecycle({
    componentWillReceiveProps() {
      const { field, firstPickup, changeDayInFormik } = this.props;
      const { value, name } = field;

      if (!value && firstPickup) {
        changeDayInFormik(name, firstPickup);
      }
    },
  })
);

const Calendar = ({
  handleChangeDay,
  field,
  day,
  form,
  labelDay,
  isRepeated,
  repeatedOrderDateInitialized,
  setDateInitialized,
  dataE2E,
  disabled,
}) => {
  const dispatch = useDispatch();
  return (
    <Fragment>
      <Flexer.Child mLeft="XS">
        <StyledDatePickerWrapper>
          {(className) => (
            <DatePicker
              disabled={disabled}
              selected={day}
              calendarClassName={className}
              onChange={(value) => {
                handleChangeDay(value);
                dispatch(setCheckTimes(true));
              }}
              customInput={
                <div>
                  <Field
                    width="S"
                    label={labelDay}
                    value={
                      isRepeated && !repeatedOrderDateInitialized
                        ? null
                        : (day && day.format('MMM DD')) || ''
                    }
                    invalid={!!getFormikError({ field, form })}
                    onChange={() => {
                      /*noop*/
                    }}
                    onFocus={isRepeated && !repeatedOrderDateInitialized && setDateInitialized}
                    dataE2E={`shipperOrder_edit__calendar_${field.name}`}
                    disabled={disabled}
                  />
                </div>
              }
            />
          )}
        </StyledDatePickerWrapper>
      </Flexer.Child>
    </Fragment>
  );
};

Calendar.propTypes = {
  handleChangeDay: PropTypes.func,
  field: PropTypes.object,
  day: PropTypes.object,
  form: PropTypes.object,
  labelDay: PropTypes.string,
  isRepeated: PropTypes.bool,
  repeatedOrderDateInitialized: PropTypes.bool,
  setDateInitialized: PropTypes.func,
  disabled: PropTypes.bool,
};

export default enhance(Calendar);
